// from prosemirror-tables
export var table = {
    group: 'block',
    content: 'tableRow+',
    tableRole: 'table',
    parseDOM: [{ tag: 'table' }],
    toDOM: function () { return ['div', { class: 'table-wrap' }, ['table', 0]]; },
};
export var tableRow = {
    content: 'tableCell+',
    tableRole: 'row',
    parseDOM: [{ tag: 'tr' }],
    toDOM: function () { return ['tr', 0]; },
};
export var tableDataCell = {
    attrs: {
        colspan: { default: 1 },
        rowspan: { default: 1 },
        colwidth: { default: null },
    },
    group: 'tableCell',
    content: 'block+',
    tableRole: 'cell',
    parseDOM: [{ tag: 'td' }],
    toDOM: function () { return ['td', 0]; },
};
export var tableHeaderCell = {
    attrs: {
        colspan: { default: 1 },
        rowspan: { default: 1 },
        colwidth: { default: null },
    },
    group: 'tableCell',
    content: 'block+',
    tableRole: 'header_cell',
    parseDOM: [{ tag: 'th' }],
    toDOM: function () { return ['th', 0]; },
};
